import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { InterviewCard, LoadingBlock } from "@/components/site/Cards";

export default function CollectionDetail() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/collections/${slug}`).then((r) => setC(r.data)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <LoadingBlock />;
  if (!c) return <div className="p-20 text-center">Collection not found.</div>;

  return (
    <div data-testid="collection-detail">
      <section className="border-b border-oc-hairline bg-oc-sand">
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16 md:py-24">
          <Link to="/collections" className="inline-flex items-center gap-2 font-ui text-xs font-bold uppercase tracking-widest text-oc-ink hover:text-oc-blue mb-8">
            <ArrowLeft className="w-3.5 h-3.5" /> All Collections
          </Link>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
            <div className="md:col-span-8">
              <div className="eyebrow text-oc-coral mb-6">Collection · {c.interview_slugs?.length || 0} interviews</div>
              <h1 className="font-editorial text-4xl md:text-6xl leading-[1.03] tracking-tight text-oc-ink">{c.title}</h1>
              {c.editorial_intro && (
                <p className="mt-6 font-editorial text-xl md:text-2xl text-oc-ink-soft leading-snug">
                  {c.editorial_intro}
                </p>
              )}
              {c.description && (
                <p className="mt-6 font-editorial text-lg text-oc-ink leading-relaxed max-w-2xl">
                  {c.description}
                </p>
              )}
            </div>
            {c.featured_image && (
              <div className="md:col-span-4">
                <div className="aspect-[4/5] overflow-hidden bg-oc-sand-warm">
                  <img src={c.featured_image} alt={c.title} className="w-full h-full object-cover" />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16">
          <div className="eyebrow text-oc-coral mb-4">Reading Path</div>
          <h2 className="font-editorial text-3xl md:text-4xl mb-12">The conversations</h2>
          <div className="space-y-16">
            {c.interviews?.map((iv, i) => (
              <div key={iv.slug} className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start pb-16 border-b border-oc-hairline last:border-0">
                <div className="md:col-span-1">
                  <div className="font-editorial text-5xl md:text-6xl text-oc-coral leading-none">{String(i + 1).padStart(2, "0")}</div>
                </div>
                <div className="md:col-span-11">
                  <InterviewCard interview={iv} variant="feature" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
